"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.calculatePlacement = exports.getVertical = exports.getHorizontal = exports.getArrowVertical = exports.getArrowLeft = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var calculatePlacements = function calculatePlacements(props) {
  if (props.positions && props.positions.box) {
    var _props$positions = props.positions,
        anchor = _props$positions.anchor,
        box = _props$positions.box,
        placement = props.placement;
    var right = document.documentElement.clientWidth - anchor.right;
    var bottom = document.documentElement.clientHeight - anchor.bottom;
    var pos = {
      left: {
        check: anchor.x < (box === null || box === void 0 ? void 0 : box.width),
        res: 'right'
      },
      right: {
        check: right < (box === null || box === void 0 ? void 0 : box.width),
        res: 'left'
      },
      top: {
        check: anchor.y < (box === null || box === void 0 ? void 0 : box.height),
        res: 'bottom'
      },
      bottom: {
        check: bottom < box.height,
        res: 'top'
      }
    };
    return pos[placement].check && pos[placement].res || placement;
  }

  return props.placement;
}; // eslint-disable-next-line complexity


var calculateVertical = function calculateVertical(props) {
  if (props.positions && props.positions.box) {
    var _props$positions2 = props.positions,
        anchor = _props$positions2.anchor,
        box = _props$positions2.box,
        _props$placement = props.placement,
        placement = _props$placement === void 0 ? 'top' : _props$placement;
    var right = document.documentElement.clientWidth - anchor.right;

    if ((placement === 'top' || placement === 'bottom') && anchor.x < (box === null || box === void 0 ? void 0 : box.width)) {
      return 'left';
    }

    if ((placement === 'top' || placement === 'bottom') && right < (box === null || box === void 0 ? void 0 : box.width)) {
      return 'right';
    }
  }

  return props.positionVertical;
}; // eslint-disable-next-line complexity


var calculateHorizontal = function calculateHorizontal(props) {
  if (props.positions && props.positions.box) {
    var _props$positions3 = props.positions,
        anchor = _props$positions3.anchor,
        box = _props$positions3.box,
        _props$placement2 = props.placement,
        placement = _props$placement2 === void 0 ? 'top' : _props$placement2;
    var bottom = document.documentElement.clientHeight - anchor.bottom;

    if ((placement === 'right' || placement === 'left') && bottom < box.height) {
      return 'top';
    }

    if ((placement === 'right' || placement === 'left') && anchor.y < (box === null || box === void 0 ? void 0 : box.height)) {
      return 'bottom';
    }
  }

  return props.positionHorizontal;
};

var calculatePlacement = function calculatePlacement(props) {
  if (props.constraintToWindow) {
    return _objectSpread(_objectSpread({}, props), {}, {
      placement: calculatePlacements(props),
      positionVertical: calculateVertical(props),
      positionHorizontal: calculateHorizontal(props)
    });
  }

  return props;
};

exports.calculatePlacement = calculatePlacement;

var getVertical = function getVertical(_ref) {
  var placement = _ref.placement,
      positions = _ref.positions,
      positionVertical = _ref.positionVertical;

  if (positions && positions.box) {
    var anchor = positions.anchor,
        box = positions.box;
    var hash = {
      bottom: "-".concat(((box === null || box === void 0 ? void 0 : box.width) - anchor.width) / 2, "px"),
      top: "-".concat(((box === null || box === void 0 ? void 0 : box.width) - anchor.width) / 2, "px"),
      left: "-".concat((box === null || box === void 0 ? void 0 : box.width) + 10, "px"),
      right: "".concat((anchor === null || anchor === void 0 ? void 0 : anchor.width) + 10, "px")
    };

    var left = _objectSpread(_objectSpread({}, hash), {}, {
      top: '0',
      bottom: '0'
    });

    var right = _objectSpread(_objectSpread({}, hash), {}, {
      top: "-".concat(box.width - anchor.width, "px"),
      bottom: "-".concat(box.width - anchor.width, "px")
    });

    return positionVertical === 'left' ? left[placement] : positionVertical === 'right' ? right[placement] : hash[placement];
  }

  return '0';
};

exports.getVertical = getVertical;

var getHorizontal = function getHorizontal(_ref2) {
  var placement = _ref2.placement,
      positions = _ref2.positions,
      positionHorizontal = _ref2.positionHorizontal;

  if (positions && positions.box) {
    var anchor = positions.anchor,
        box = positions.box;
    var hash = {
      bottom: "".concat(anchor.height + 10, "px"),
      top: "-".concat(box.height + 10, "px"),
      left: "-".concat(box.height / 2 + anchor.height / 2 - anchor.height, "px"),
      right: "-".concat(box.height / 2 + anchor.height / 2 - anchor.height, "px")
    };

    var top = _objectSpread(_objectSpread({}, hash), {}, {
      left: "-".concat(box.height - anchor.height, "px"),
      right: "-".concat(box.height - anchor.height, "px")
    });

    var bottom = _objectSpread(_objectSpread({}, hash), {}, {
      left: '0',
      right: '0'
    });

    return positionHorizontal === 'top' ? top[placement] : positionHorizontal === 'bottom' ? bottom[placement] : hash[placement];
  }

  return '0';
}; // eslint-disable-next-line complexity


exports.getHorizontal = getHorizontal;

var getArrowLeft = function getArrowLeft(_ref3) {
  var placement = _ref3.placement,
      positions = _ref3.positions,
      arrowOffset = _ref3.arrowOffset;

  if (positions && positions.box) {
    if (placement === 'bottom' || placement === 'top') {
      var left = positions.box.width / 2;
      return arrowOffset ? "".concat(left + arrowOffset, "px") : "".concat(left, "px");
    }
  }
}; // eslint-disable-next-line complexity


exports.getArrowLeft = getArrowLeft;

var getArrowVertical = function getArrowVertical(_ref4) {
  var placement = _ref4.placement,
      positions = _ref4.positions,
      arrowOffset = _ref4.arrowOffset;

  if (positions && positions.box) {
    if (placement === 'left' || placement === 'right') {
      var height = positions.box.height / 2;
      return arrowOffset ? "".concat(height + arrowOffset, "px") : "".concat(height, "px");
    }
  }
};

exports.getArrowVertical = getArrowVertical;
//# sourceMappingURL=helpers.js.map